import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { SlideInPanelAnchorLocation } from "@redotech/redo-storefront-common/slide-in-panel-anchor-location";
import { assertNever } from "@redotech/util/type";
import classNames from "classnames";
import { memo, useMemo } from "react";
import { RedoButton } from "./arbiter-components/buttons/redo-button";
import { Flex } from "./flex";
import * as slideInPanelCss from "./slide-in-panel.module.css";

export const SlideInPanel = memo(function SlideInPanel({
  children,
  anchorLocation,
  open,
  handleCloseClick,
  readonlyPreview = false,
  dataTarget,
  closeButtonDataTarget,
}: {
  children: React.ReactNode | React.ReactNode[];
  anchorLocation: SlideInPanelAnchorLocation;
  open: boolean;
  handleCloseClick: () => void;
  readonlyPreview?: boolean;
  dataTarget?: string;
  closeButtonDataTarget?: string;
}) {
  const _anchorLocation = useMemo(() => {
    switch (anchorLocation) {
      case SlideInPanelAnchorLocation.BOTTOM_LEFT:
        return slideInPanelCss.bottomLeft;
      case SlideInPanelAnchorLocation.BOTTOM_MIDDLE:
        return slideInPanelCss.bottomMiddle;
      case SlideInPanelAnchorLocation.BOTTOM_RIGHT:
        return slideInPanelCss.bottomRight;
      case SlideInPanelAnchorLocation.TOP_LEFT:
        return slideInPanelCss.topLeft;
      case SlideInPanelAnchorLocation.TOP_MIDDLE:
        return slideInPanelCss.topMiddle;
      case SlideInPanelAnchorLocation.TOP_RIGHT:
        return slideInPanelCss.topRight;
      default:
        assertNever(anchorLocation);
    }
  }, [anchorLocation]);

  return open ? (
    <Flex
      className={classNames(slideInPanelCss.panelContainer, {
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        [_anchorLocation]: !readonlyPreview,
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        [slideInPanelCss.readonlyPreview]: readonlyPreview,
      })}
      data-target={dataTarget}
    >
      <RedoButton
        className={slideInPanelCss.closeIconButton}
        dataTarget={closeButtonDataTarget}
        hierarchy="tertiary"
        IconLeading={XCloseIcon}
        onClick={(event) => {
          handleCloseClick();
          event.stopPropagation();
        }}
        size="md"
        theme="normal"
      />
      {children}
    </Flex>
  ) : null;
});
